var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "#717579",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5858 37.89L31.3858 31.09L24.5858 24.29L23 25.8772L28.2129 31.0901L23 36.303L24.5858 37.89Z",
    fill: "#717579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6913 37.89L39.4913 31.09L32.6913 24.29L31.1055 25.8772L36.3184 31.0901L31.1055 36.303L32.6913 37.89Z",
    fill: "#717579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardEnabled);
export default __webpack_public_path__ + "static/media/forwardEnabled.af6cb71b3f1dc5be4e1e80d3dae0cd4f.svg";
export { ForwardRef as ReactComponent };